<template>
  <div
    ref="contextMenu"
    class="context-menu"
    v-if="hasEnableMenu"
    :style="contextMenuStyle"
  >
    <context-menu-item
      v-if="isEnableHistory"
      @click="onClickHistory"
      text="過去履歴表示"
    >
      <history-icon slot="context-menu-item-icon"></history-icon>
    </context-menu-item>
    <context-menu-item
      v-if="isEnableOffingPOint"
      @click="onClickOffingPoint"
      text="沖波ポイント予測"
    >
      <offing-point-icon slot="context-menu-item-icon"></offing-point-icon>
    </context-menu-item>
  </div>
</template>

<script>
import ContextMenuItem from "./ContextMenuItem.vue";
import HistoryIcon from "./HistoryIcon.vue";
import OffingPointIcon from "./OffingPointIcon.vue";

export const MENUS = {
  HISTORY: "HISTORY",
  OFFING_POINT: "OFFING_POINT",
};

export const MENU_EVENTS = {
  HISTORY: "history",
  OFFING_POINT: "offing-point",
};

export default {
  name: "ContextMenu",
  components: {
    ContextMenuItem,
    HistoryIcon,
    OffingPointIcon,
  },
  props: {
    menuItems: {
      type: Array, // MenuItem[]
      default() {
        return [];
      },
    },
    enableMenus: {
      type: Object, // {[key: string]: boolean} // key: MENUS
      default: () => ({}),
    },
    initialPosition: {
      type: Object, // {x: number; y: number}
      required: true,
    },
  },
  data() {
    return {
      isVisible: false, // 位置計算をするまで非表示する
      contextMenuStyle: {},
    };
  },
  computed: {
    hasEnableMenu() {
      return Object.keys(MENUS).some(menu => this.enableMenus[menu]);
    },
    isEnableHistory() {
      return this.enableMenus[MENUS.HISTORY] === true;
    },
    isEnableOffingPOint() {
      return this.enableMenus[MENUS.OFFING_POINT] === true;
    },
  },
  watch: {
    initialPosition: {
      handler() {
        this.isVisible = false;
        this.contextMenuStyle = this.calcContextMenuStyle();
        this.$nextTick(() => {
          this.isVisible = true;
          this.contextMenuStyle = this.calcContextMenuStyle();
        });
      },
      immediate: true,
    },
  },
  methods: {
    onClickHistory(event) {
      this.$emit(MENU_EVENTS.HISTORY, event);
    },
    onClickOffingPoint(event) {
      this.$emit(MENU_EVENTS.OFFING_POINT, event);
    },
    isRightOverflow() {
      if (!this.$refs.contextMenu) return false;
      return (
        window.innerWidth < this.$refs.contextMenu.getBoundingClientRect().right
      );
    },
    isBottomOverflow() {
      if (!this.$refs.contextMenu) return false;
      return (
        window.innerHeight <
        this.$refs.contextMenu.getBoundingClientRect().bottom
      );
    },
    calcLeftPosition() {
      const { x } = this.initialPosition;
      if (this.isRightOverflow()) {
        return x - this.$refs.contextMenu.offsetWidth;
      }
      return x;
    },
    calcTopPosition() {
      const { y } = this.initialPosition;
      if (this.isBottomOverflow()) {
        return y - this.$refs.contextMenu.offsetHeight;
      }
      return y;
    },

    calcContextMenuStyle() {
      return {
        visibility: this.isVisible ? "visible" : "hidden",
        left: `${this.calcLeftPosition()}px`,
        top: `${this.calcTopPosition()}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.context-menu {
  z-index: 4001; // 右メニューの手前に出す
  position: absolute;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: max-content;

  border-radius: 5px;
  background-color: $aisea-white;

  cursor: pointer;
  :first-child {
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  :last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
</style>
